/**
 * Node.JS/NPM Modules
 */
/**
 * Loacl Modules
 */
const logger = require('./logger');
const signaling_module = require('./signaling_module');
/**
 * Module Variables
 */
const TAG = '[peer_connection]';
let peerConnectionConfig = {
    'iceServers': [{
        'urls': 'stun:stun.services.mozilla.com'
     }, {
        'urls': 'stun:stun.l.google.com:19302'
     }]
};
const peerConnectionOptions = {
    optional: [
        {
            DtlsSrtpKeyAgreement: true
        },
     ]
};
let peerConnection;
let savedLocalOffer = null;
let shouldCreateOffer = false;
let roomId = 'demo';
let userId;
let peerId;
let maxBw = 1000;
let recvOnly = false;
let notifyICEReset = ()=>{};
let notifyConnected = ()=>{};
/**
 * Module Functions
 */
/**
 * Will create a new RTCPeerConnection according to options and returns it.
 * @param  {Object} options The peerConnection options
 * @return {RTCPeerConnection}  The created peerConnection.
 */
let createPeerConnection = (options) => {
    roomId = options.roomId || roomId;
    maxBw = options.maxBw || maxBw;
    peerId = options.peerId;
    userId = options.userId;
    recvOnly = options.recvOnly;
    notifyICEReset = options.notifyICEReset;
    notifyConnected = options.notifyConnected;
    peerConnectionConfig.iceServers = options.iceServers || peerConnectionConfig.iceServers;
    if(options.peerConnectionConfig)  peerConnectionConfig = options.peerConnectionConfig;
    logger.debug(TAG, 'Creating A New Peer Connection for roomId', roomId);
    if(options.maxBundle === true) {
        logger.debug(TAG, "maxBundle set to true");
        peerConnectionConfig.bundlePolicy = "max-bundle";
    }
    peerConnection = new RTCPeerConnection(peerConnectionConfig, peerConnectionOptions);
    peerConnection.onicecandidate = options.gotIceCandidate;
    peerConnection.ontrack = options.gotRemoteStream;
    peerConnection.onremovestream = options.lostRemoteStream;
    peerConnection.onnegotiationneeded = _negotiationNeeded;
    peerConnection.onsignalingstatechange = _signalingStateChange;
    peerConnection.oniceconnectionstatechange = _iceConnectionStateChanged;
    if(recvOnly) notifyConnected();
    return peerConnection;
};

let closePeerConnection = () => {
    if (peerConnection) {
        peerConnection.close();
        peerConnection = null;
    }
};

let restartIce = () => {
  logger.debug(TAG, 'Restarting ICE...');
  peerConnection.createOffer({iceRestart: true})
    .then(_gotDescription)
    .catch(_errorHandler);
};

/**
 * A Callback function for RTCPeerConnection.onnegotiationneeded event
 * @param  {Object} event onnegotiationneeded event - not used
 */
let _negotiationNeeded = (event) => {
    logger.debug(TAG, 'negotiationNeeded, signaling state=' +  peerConnection.signalingState + ' savedLocalOffer=' + savedLocalOffer);
    if (!savedLocalOffer && peerConnection.signalingState === "stable") {
        logger.debug(TAG, 'negotiationNeeded, calling createOffer');
        peerConnection.createOffer()
          .then(_gotDescription)
          .catch(_errorHandler);
    } else {
        logger.debug(TAG, 'negotiationNeeded, already ongoing, postpone until stable');
        shouldCreateOffer = true;
    }
};

/**
 * A Callback function for RTCPeerConnection.createOffer function. will set the sdp in local description
 * @param  {sdp} description  session description
 */
let _gotDescription = (description) => {
    logger.debug(TAG, 'got description of type', description.type);
    var data = JSON.stringify({
        'sdp': description,
        'roomId': roomId,
        'userId': userId,
        'peerId': peerId,
        'recvOnly': recvOnly,
        'maxBw': maxBw
    });

    if (description.type == "offer") {
        if (savedLocalOffer !== null) {
            logger.debug(TAG, 'got new local offer, but already sent one, skipping');
            return;
        }

        logger.debug(TAG, 'saving new local offer, will call setLocalDescription when answer is received');
        savedLocalOffer = description;
        signaling_module.send(data);
        return;
    }

    peerConnection.setLocalDescription(description)
      .then(() => {
        signaling_module.send(data);
      })
      .catch(_errorHandler);
};

/**
 * Generic Error Handler
 * @param  {Error} err
 */
let _errorHandler = (err) => {
    logger.error(TAG, 'Error:', err);
};

/**
 * A Callback function for RTCPeerConnection.onsignalingstatechange
 * @param  {Object} event onsignalingstatechange event - not used
 */
let _signalingStateChange = (event) => {
    if (!peerConnection) return;
    logger.debug(TAG, 'signalingStateChange, signaling state', peerConnection.signalingState);
    if (peerConnection.signalingState === "stable" && shouldCreateOffer === true) {
        logger.debug(TAG, 'signalingStateChange, creating offer');
        shouldCreateOffer = false;
        peerConnection.createOffer()
          .then(_gotDescription)
          .catch(_errorHandler);
    }
};

let _iceConnectionStateChanged = (event) => {
  if (!peerConnection) return;
  if (peerConnection.iceConnectionState === "disconnected" ||
      peerConnection.iceConnectionState === "closed") {
      // Handle the failure - restart ICE
      logger.debug(TAG, 'ICE connection state:',peerConnection.iceConnectionState,'Restarting ICE...');
      notifyICEReset();
      //restartIce();

  } else if(peerConnection.iceConnectionState === 'connected'){
    if(!recvOnly) notifyConnected();
  } else if(peerConnection.iceConnectionState === 'failed'){
    // Need to try and reconnect the socket...
    notifyConnected(true);
  }
};


let onRemoteIce = (ice) => {
    if (!peerConnection) return;
    if (savedLocalOffer == null && peerConnection.signalingState === "stable") {
        logger.debug(TAG, 'onRemoteIce adding ice candidate ' + ice);
        peerConnection.addIceCandidate(new RTCIceCandidate(ice))
          .then(_=>{
            logger.debug(TAG, 'ICE added Successfully');
          })
          .catch((err)=>{
            logger.error(TAG, 'Failed To Add ICE. ERROR:', err);
          });
    } else {
        logger.debug(TAG, 'onRemoteIce delaying ice candidate ' + ice);
        setTimeout(onRemoteIce, 100, ice);
    }
};

/**
 * This will set the remote description in the PC. and will generate an answer.
 * @param {sdp} sdp session description
 */
let onRemoteDescription = (sdp) => {
    if (!peerConnection) return;

    logger.debug(TAG, 'received remote description type=' + sdp.type);
    if (sdp.type == "answer") {
        // got remote answer, can finally set local description (to avoid glare condition)
        if (savedLocalOffer == null) {
            logger.error(TAG, 'Error, received remote answer, but no saved local offer');
        } else {
            peerConnection.setLocalDescription(savedLocalOffer).then(() => {
                savedLocalOffer = null;
                logger.debug(TAG, 'Setting saved local offer before received answer');
                setRemoteDescription(sdp);
            }).catch(_errorHandler);
        }
        return;
    }

    // got remote offer
    if (savedLocalOffer) {
        logger.debug(TAG, 'Remote offer received, but have saved local offer, dropping saved offer');
        savedLocalOffer = null;
    }

    setRemoteDescription(sdp);
};

let setRemoteDescription = (sdp) => {
    logger.debug(TAG, 'Setting remote description, state=' + peerConnection.signalingState);
    peerConnection.setRemoteDescription(sdp).then(() => {
        if (sdp.type == "offer") {
            logger.debug(TAG, 'Creating sdp answer.');
            peerConnection.createAnswer()
              .then(_gotDescription)
              .catch(_errorHandler);
        }
    }).catch((err) => {
        logger.error(TAG, 'Error setting remote description: state=' + peerConnection.signalingState + ' error=' + err);
    });
};

/**
 * This will update the recvOnly flag - used only for signaling current state to the server and does not directly affect local media
 * @param {_recvOly} true if only receving media, false if sending and receiving
 */
let setRecvOnly = (_recvOnly) => {
    recvOnly = _recvOnly;
};

/**
 * Removes a stream from the peerConnection
 * @param  {MediaStream} stream a WebRTC Media sream
 */
let removeStream = (stream) => {
    if (stream && peerConnection) {
        logger.debug(TAG, 'Removed Stream');
        peerConnection.removeStream(stream);
    } else {
        logger.debug(TAG, 'Attempted to remove a null stream...');
    }
};

/**
 * This function returns a promise. it will get the stream stats from the PeerConnection.
 * @return {Promise} With stats object.
 */
let getStats = () => {
    return new Promise((resolve, reject) => {
        if (peerConnection) {
            //logger.debug(TAG, 'Getting stats');
            // Working on Chrome 60
            if(global.adapter.browserDetails.browser !== 'chrome') resolve(null);
            else peerConnection.getStats((stats) => {
                resolve(stats);
            }, null, function() {});
        } else {
            logger.debug(TAG, 'No PeerConnection');
            if (reject) reject();
        }
    });
};

let getStats2 = () => {
  return new Promise((resolve, reject) => {
      if (peerConnection) {
        logger.debug(TAG, 'Getting stats (getStats2())');
        let allStatsPromises = []
        top.pc = peerConnection;
        peerConnection.getLocalStreams().forEach((s)=>{
          s.getTracks().forEach(t=>{
            logger.debug(TAG,'LOCAL TRACK->', t);
            allStatsPromises.push(peerConnection.getStats(t));
          });
        });
        peerConnection.getRemoteStreams().forEach((s)=>{
          s.getTracks().forEach(t=>{
            logger.debug(TAG, 'REMOTE TRACK->', t);
            allStatsPromises.push(peerConnection.getStats(t));
          });
        });
        Promise.all(allStatsPromises)
        .then((stats)=>{
          resolve(stats);
        })
        .catch(err =>{
          logger.error(TAG, 'ERROR', err);
        });
      }
    });
}

/**
 * This will return a streamId (or null) from a given trackId.
 * @param  {String}  trackId The track that you wish to know the streamId for
 * @param  {Boolean} isVideo is the track a video(true) or audio(false)
 * @return {String}          The streamId. if not found - null
 */
let getStreamIdFromTrackId = (trackId, isVideo) => {
    let streamsFound = peerConnection.getRemoteStreams()
        .filter((stream) => {
            let foundTraks = [];
            if (isVideo) {
                foundTraks = stream.getVideoTracks()
                    .filter((track) => {
                        return trackId === track.id;
                    });
            } else {
                foundTraks = stream.getAudioTracks()
                    .filter((track) => {
                        return trackId === track.id;
                    });
            }
            if (foundTraks.length > 0) {
                return true;
            }
        });
    if (streamsFound.length <= 0) {
        streamsFound = peerConnection.getLocalStreams()
            .filter((stream) => {
                let foundTraks = [];
                if (isVideo) {
                    foundTraks = stream.getVideoTracks()
                        .filter((track) => {
                            return trackId === track.id;
                        });
                } else {
                    foundTraks = stream.getAudioTracks()
                        .filter((track) => {
                            return trackId === track.id;
                        });
                }
                if (foundTraks.length > 0) {
                    return true;
                }
            });
    }
    if (streamsFound.length > 0) {
        return streamsFound[0].id;
    }
    return null;
};

let getPeerConnection = () =>{
  return peerConnection;
}

/**
 * Module Interface
 */
module.exports = {
    createPeerConnection: createPeerConnection,
    closePeerConnection: closePeerConnection,
    getPeerConnection: getPeerConnection,
    onRemoteDescription: onRemoteDescription,
    onRemoteIce: onRemoteIce,
    setRecvOnly: setRecvOnly,
    removeStream: removeStream,
    getStats: getStats,
    getStreamIdFromTrackId: getStreamIdFromTrackId,
    restartIce: restartIce,
    getStats2: getStats2
};



// WEBPACK FOOTER //
// ./src/Modules/peer_connection.js